import React from "react";
import parse from "html-react-parser";
import "./eventDetail.css";

export default function EventDetail2({ item, handleCalendarMove, defaultLanguage }) {
  // const myDivRef = useRef(null);
  // const scrollToTop = () => {

  //   alert("tt")
  //   if (myDivRef.current) {
  //     myDivRef.current.scrollTop = 0;
  //   }
  // };

  // const handleCalendarMove1 = () => {
  //   scrollToTop();
  // };

  return (
    <>
      <div className="  mx-auto p-4 md:p-8 overflow-auto ">
        <div className="post  ">
          <div className="flex flex-wrap break-word  text-3xl md:text-2xl font-bold mb-4 "> {` ${defaultLanguage === "ko" ? "게시판" : "Board"}`}</div>

          <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" />
          <div className=" break-all text-lg md:text-xl font-bold mb-4">{item?.Title || ""}</div>
          <span className="text-sm md:text-base text-gray-600"> {` ${defaultLanguage === "ko" ? "작성자 : " : "WriterName : "}${item.WriterName}`}</span>
          <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" />
          {/* <pre className="text-sm md:text-lg  break-all scale-70 md:scale-100 ">{parse(item?.ContentHtml || "")}</pre> */}
          {/* <pre className=" text-sm md:text-lg  whitespace-pre-wrap  ">{parse(item?.ContentHtml || "")}</pre> */}

          <div className=" text-sm md:text-lg  parsed-content ">{parse(item?.ContentHtml || "")}</div>

          <hr className="h-px mx-0 my-4   border-0  bg-gradient-to-r from-transparent via-black/100 to-transparent" />

          <div className="flex justify-center">
            <button
              className="bg-black py-3 px-10 text-white  font-semibold"
              onClick={() => {
                handleCalendarMove();
              }}
            >
              {` ${defaultLanguage === "ko" ? "목록보기" : "List view"}`}
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
